import alloyAnalytics from '@telus/alloy-analytics'

export interface YouTubePlayer {
  getCurrentTime(): number
  getDuration(): number
  getVideoData(): {
    title: string
    video_id: string
    author: string
  }
}

type VideoEventProps = { videoId: string; player: YouTubePlayer }

const getMedia = ({ videoId, player }: VideoEventProps) => ({
  videoName: player.getVideoData().title,
  videoID: videoId,
  videoURL: `https://www.youtube.com/watch?v=${videoId}`,
  videoPlayhead: Math.ceil(player.getCurrentTime()),
  videoDuration: Math.ceil(player.getDuration()),
  videoPlayer: 'youtube',
})

const alloyEvents = {
  play: (props: VideoEventProps) => {
    alloyAnalytics.event('videoStart').webInteraction({ name: 'video_start' }).media(getMedia(props)).fire()
  },
  pause: (props: VideoEventProps) => {
    alloyAnalytics.event('videoPause').webInteraction({ name: 'video_pause' }).media(getMedia(props)).fire()
  },
  resume: (props: VideoEventProps) => {
    alloyAnalytics.event('videoResume').webInteraction({ name: 'video_resume' }).media(getMedia(props)).fire()
  },
  complete: (props: VideoEventProps) => {
    alloyAnalytics.event('videoComplete').webInteraction({ name: 'video_complete' }).media(getMedia(props)).fire()
  },
}

export default alloyEvents
